/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents, getAelEventsArray } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData } from '@gh/common-shared';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import { JobLetterListTabBusinessService } from '../../resources/job-letter-list-tab-business.service';
import { LetterTemplateAvailability } from '../../resources/job-letters.model';
import { JobLetterListTabFormState } from './job-letter-list-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-letter-template-list-tab',
  templateUrl: 'job-letter-list-tab.component.html',
  providers: [
    JobLetterListTabFormState,
  ],
})
export class JobLetterListTabComponent extends AbstractFormComponent<LetterTemplateAvailability> implements OnInit {

  jobLetters: LetterTemplateAvailability;

  constructor(private route: ActivatedRoute,
              private navigationService: BuilderNavigationService,
              public form: JobLetterListTabFormState,
              private businessService: JobLetterListTabBusinessService,
              private pipelines: FormActionPipelines,
              private commonActions: CommonActions,
              private dialogService: DialogService,
              private userContext: BuilderUserContext,
  ) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<LetterTemplateAvailability>> {
    return this.pipelines.complete({
      execute: this.commonActions.execute((state) =>
        this.businessService.update(state.value),
      ),
      finish: (state: FormFlowState<LetterTemplateAvailability>) => {
        const { value } = state;

        this.form.build(value);

        this.jobLetters = value;
      },
    });
  }

  ngOnInit(): void {
    const { jobLetters } = getRouteInitData(this.route);

    assign(this, { jobLetters });
    this.form.build(jobLetters);
  }

  goToAel(): void {
    const officeId = this.userContext.office!.id;
    this.navigationService.goToAel({
      entityId: officeId,
      entityType: 'JOB_LETTER',
      eventTypeIds: getAelEventsArray(AelEvents.JobLetter),
      label: 'lbl_job_letters',
    });
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => {
        this.form.build(this.jobLetters);
      });
  }
  sortByName(aNull: any, bNull: any, rowA: any, rowB: any): number {
    const a = rowA.data.value.fileName;
    const b = rowB.data.value.fileName;
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }
    return 0;
  }

  sortByCheck(aNull: any, bNull: any, rowA: any, rowB: any): number {
    const a = rowA.data.value.isAvailable;
    const b = rowB.data.value.isAvailable;
    if (!!a && !b) {
      return 1;
    } else if (!a && !!b) {
      return -1;
    } else {
      return 0;
    }
  }
}
